<template>
  <v-container fluid>
    <div class="wrapper">
      <v-dialog v-model="isLoadingData" max-width="320" persistent>
        <v-list class="py-5" color="primary" elevation="12" rounded>
          <v-list-item class="d-flex justify-space-between">
            <div>
              <span style="color: white; font-size: large;">Carregando dados...</span>
            </div>
            <div>
              <v-progress-circular color="#1A237E" indeterminate size="32" width="2"></v-progress-circular>
            </div>
          </v-list-item>
        </v-list>
      </v-dialog>
      <div class="left-div">
        <SignaturesStepper
            :steps="determinateSteps"
            @changeTab="nextTab"
        />
        <div class="components-container">
          <EnvelopeBasicsTab
              ref="EnvelopeBasicsTab"
              :param="envelopeDataClickSign"
              :show="visibleTabs['envelope_basics']"
              :idEnvelope="signatureFlowFirebase.id_envelope"
              :envelopeStatus="envelopeDataClickSign.attributes.status"
          />

          <DocumentsTabs
              ref="DocumentsTabs"
              @update-firebase-data="updateSignatureFlowFirebase"
              :param="documentsDataClickSign"
              :show="visibleTabs['documents']"
              :envelopeStatus="envelopeDataClickSign.attributes.status"
              :idEnvelope="signatureFlowFirebase.id_envelope"/>

          <SignersTab
              ref="SignersTabs"
              @update-firebase-data="updateSignatureFlowFirebase"
              :param="signersDataClickSign"
              :show="visibleTabs['signers']"
              :envelopeStatus="envelopeDataClickSign.attributes.status"
              :idEnvelope="signatureFlowFirebase.id_envelope"/>

          <NotificationsTab
              ref="SignersTabs"
              :param="signersDataClickSign"
              :show="visibleTabs['notifications']"
              :envelopeStatus="envelopeDataClickSign.attributes.status"
              :idEnvelope="signatureFlowFirebase.id_envelope"/>

        </div>
      </div>

      <div>
        <v-divider style="background-color: #000;" vertical></v-divider>
      </div>

      <div class="right-div">
        <h2>
          Histórico
        </h2>

        <v-row>
          <v-col>
            <v-card v-for="entry in events" :key="entry.id" class="mb-3" style="width: 100%;">
              <v-card-title>{{ entry.name }}</v-card-title>
              <v-card-subtitle>ID: {{ entry.id }}</v-card-subtitle>
              <v-card-text>
                <v-icon left>mdi-calendar</v-icon>
                {{ formatDate(entry.actionDate) }}
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

      </div>
    </div>

  </v-container>
</template>

<script>
import SignaturesDetailsScript from "./SignaturesDetailsScript";

export default SignaturesDetailsScript;
</script>

<style scoped>

.wrapper {
  display: flex;
  gap: 1rem;
  height: 90dvh;
  overflow-x: hidden;
  overflow-y: hidden;
}

.left-div {
  width: 60%;
}

.right-div {
  width: 40%;
  overflow-y: scroll;
  overflow-x: hidden;
  word-break: break-word;
}

.components-container {
  width: 101%;
  z-index: 0;
  margin-top: 10px;
}
</style>